
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

const UserPermissions = () => {
  // Mock permissions data
  const permissionSets = [
    {
      section: 'Content Management',
      permissions: [
        { name: 'View Content', admin: true, editor: true, viewer: true },
        { name: 'Create Content', admin: true, editor: true, viewer: false },
        { name: 'Edit Content', admin: true, editor: true, viewer: false },
        { name: 'Delete Content', admin: true, editor: false, viewer: false },
        { name: 'Publish Content', admin: true, editor: true, viewer: false },
      ]
    },
    {
      section: 'User Management',
      permissions: [
        { name: 'View Users', admin: true, editor: true, viewer: false },
        { name: 'Create Users', admin: true, editor: false, viewer: false },
        { name: 'Edit Users', admin: true, editor: false, viewer: false },
        { name: 'Delete Users', admin: true, editor: false, viewer: false },
        { name: 'Assign Permissions', admin: true, editor: false, viewer: false },
      ]
    },
    {
      section: 'Service Management',
      permissions: [
        { name: 'View Services', admin: true, editor: true, viewer: true },
        { name: 'Create Services', admin: true, editor: true, viewer: false },
        { name: 'Edit Services', admin: true, editor: true, viewer: false },
        { name: 'Delete Services', admin: true, editor: false, viewer: false },
      ]
    }
  ];
  
  return (
    <div>
      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Role-Based Permissions</CardTitle>
          <CardDescription>
            Manage what actions each user role can perform within the system.
            Changes apply to all users with the corresponding role.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {permissionSets.map((set, index) => (
              <div key={index}>
                <h3 className="text-lg font-medium mb-4">{set.section}</h3>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="w-[40%]">Permission</TableHead>
                      <TableHead className="text-center">Admin</TableHead>
                      <TableHead className="text-center">Editor</TableHead>
                      <TableHead className="text-center">Viewer</TableHead>
                      <TableHead className="w-[10%]"></TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {set.permissions.map((permission, permIndex) => (
                      <TableRow key={permIndex}>
                        <TableCell>{permission.name}</TableCell>
                        <TableCell className="text-center">
                          <Switch checked={permission.admin} disabled={true} />
                        </TableCell>
                        <TableCell className="text-center">
                          <Switch checked={permission.editor} />
                        </TableCell>
                        <TableCell className="text-center">
                          <Switch checked={permission.viewer} />
                        </TableCell>
                        <TableCell>
                          <Button variant="ghost" size="icon">
                            <Info className="h-4 w-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ))}
          </div>
          
          <div className="mt-6 flex justify-end gap-2">
            <Button variant="outline">Reset to Defaults</Button>
            <Button>Save Changes</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserPermissions;
